export default __webpack_public_path__ + "static/media/Contentina.79c264c4.jpg";